import styled, { css } from 'styled-components';

import { ThemeMode } from '@/helpers/enums';

interface ScPromoCodeInputProps {
  mode?: ThemeMode;
  inputPointerEventsNone?: boolean;
}

export const ScPromoCodeInput = styled.div<ScPromoCodeInputProps>`
  & input {
    font-weight: 700;
    text-transform: uppercase;

    &::placeholder {
      text-transform: capitalize;
    }
  }

  ${({ inputPointerEventsNone }) =>
    inputPointerEventsNone &&
    css`
      & input {
        pointer-events: none;
      }
    `}

  .info-message {
    display: flex;
    align-items: center;
    gap: 4px;

    a {
      text-decoration: underline;
    }

    svg {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      object-fit: contain;

      path {
        fill: ${({ theme, mode }) =>
          mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
      }
    }
  }

  button {
    min-width: 93px;
  }

  & .error b {
    cursor: pointer;
  }
`;
